module.exports = __webpack_public_path__ + "img/coin.dbb1c3f4.png";